<template>
    <b-form-row>
        <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="id" :title="title">
            <ItemBemPermanenteList :isAbertoFromModal="true" @onDblClickItemBemPermanente="itemBemPermanenteSelect" />
        </b-modal>

        <template v-if="mode === 'finder'">
            <lg-form-input-finder v-model="localObject" @handleClean="itemBemPermanenteSelect"
                fieldDescription="descricaoResumida" :label="label" invalidFeedback="Bem deve ser informado!"
                description="" :showClear="podeApagar" :disabled="disabled">
                <template #prepend>
                    <b-button @click="show" class="btn-input-finder" pressed v-if="podeMudar" :disabled="disabled">
                        <b-icon icon="search" />
                    </b-button>
                </template>

            </lg-form-input-finder>
        </template>

        <template v-else-if="mode === 'button'">
            <b-button @click="show" variant="success" style="height: 30px" pill size="sm" :disabled="disabled">
                <b-icon icon="plus" /> {{ label }}
            </b-button>
        </template>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"

export default {
    name: "LgFinderPageItemBemPermanente",
    components: {  LgFormInputFinder, ItemBemPermanenteList: () => import("../../modules/patrimonio/item-bem-permanente/ItemBemPermanenteList.vue") },
    props: {
        
        id: String,
        onselect: Function,
        user: Object,
        value: Object,
        error: {
            type: Object,
            default: null,
        },
        podeMudar: {
            type: Boolean,
            default: true,
        },
        podeApagar: {
            type: Boolean,
            default: true,
        },
        prefix: {
            type: [String, Array],
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        mode: {
            type: String,
            default: 'finder',
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, "Item Bem Permanente"].filter(item => item && item != "");
        },
        title() {
            return this.updatedPrefix.join(" > ");
        },
    },
    data() {
        return {
            localObject: this.value,
        }
    },
    methods: {
        async show() {
            this.$bvModal.show(this.id)
        },
        async itemBemPermanenteSelect(item) {
            this.localObject = item            
            this.$emit("onselect", item)
            this.$bvModal.hide(this.id)
        },
    },
}
</script>
